export function openFlaggedScript(opts: {
  hasUnackedFlag: boolean;
  localId: string;
  remoteId: string | null | undefined;
  ack: (localId: string, remoteId: string) => void;
  onOpen: (scriptId: string) => void;
}): void {
  if (opts.hasUnackedFlag && opts.remoteId) {
    opts.ack(opts.localId, opts.remoteId);
  }
  opts.onOpen(opts.localId);
}
